import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideStates } from '@ngxs/store';
import { AuthModuleConfig } from '@portal-core/auth/models/auth-module-config.model';
import { AuthModuleConfigService } from '@portal-core/auth/services/auth-module-config.service';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { AuthState } from '@portal-core/auth/services/auth-data.service';

/**
 * Provides the auth services, state, and configuration. The standalone replacement for
 * `AuthServicesModule.forRoot(config)` — call it in an application's bootstrap providers.
 * @param config The auth module configuration (event handlers and effects).
 */
export function provideAuthServices(config: AuthModuleConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideStates([AuthState]),
    // Provide here so that the constructor for AuthService runs early. This gives the AuthService time to create the auth effects.
    AuthService,
    {
      provide: AuthModuleConfigService,
      useValue: config
    }
  ]);
}
